const ROUTE_VIEW_HOME = [
  // 搜索
  { path: '/search', name: '搜索', h5Uri: '/home/search/search', nativeUri: null, whiteList: true },
  { path: '/search/doctor', name: '相关医生', h5Uri: '/home/search/relevant_doctor', nativeUri: null, whiteList: true },
  { path: '/search/department', name: '相关科室', h5Uri: '/home/search/relevant_department', nativeUri: null, whiteList: true },
  { path: '/search/hospital', name: '相关医院', h5Uri: '/home/search/relevant_hospital', nativeUri: null, whiteList: true },
  { path: '/hospital/index', name: '医院主页', h5Uri: '/home/search/hospital_index', nativeUri: null, whiteList: true },
  { path: '/hospital/intro', name: '医院介绍', h5Uri: '/home/search/hospital_introduction', nativeUri: null, whiteList: true },
  { path: '/doctor/index', name: '医生主页', h5Uri: '/home/search/doctor_index', nativeUri: null, whiteList: true },
  { path: '/hospital/map', name: '院内地图', h5Uri: '/home/search/hospital_map', nativeUri: null, whiteList: true },
  { path: '/cardCharge', name: '就诊卡充值', h5Uri: '/home/search/card_charge', nativeUri: null },
  { path: '/chargeSuccess', name: '就诊卡充值成功', h5Uri: '/home/search/charge_success', nativeUri: null },
  { path: '/evaluate', name: '就医反馈入口', h5Uri: '/home/search/evaluate', nativeUri: null },

  //候诊排队
  { path: '/queueup', name: '候诊排队', h5Uri: '/home/search/queueup', nativeUri: null },
  // 住院押金
  { path: '/deposit', name: '住院押金', h5Uri: '/home/deposit/deposit', nativeUri: null },
  { path: '/deposit/pay', name: '住院押金缴纳', h5Uri: '/home/deposit/deposit_pay', nativeUri: null },
  { path: '/deposit/success', name: '住院押金缴纳成功', h5Uri: '/home/deposit/pay_success', nativeUri: null },

  // 住院列表
  { path: '/hospitalization/list', name: '住院列表', h5Uri: '/home/hospitalization_list/hospitalization_list', nativeUri: null },
  { path: '/hospitalization/dayList', name: '住院日清单', h5Uri: '/home/hospitalization_list/hospital_day_list', nativeUri: null },
  { path: '/hospitalization/dayDetail', name: '住院日清单明细', h5Uri: '/home/hospitalization_list/hospital_day_detail', nativeUri: null },

  // 建档
  { path: '/number/bind', name: '就诊号绑定', h5Uri: '/home/number_bind/number_bind', nativeUri: null },
  { path: '/number/confirm', name: '确认绑定', h5Uri: '/home/number_bind/number_confirm', nativeUri: null },
  { path: '/number/success', name: '绑定成功', h5Uri: '/home/number_bind/bind_success', nativeUri: null },
  { path: '/number/fail', name: '绑定失败', h5Uri: '/home/number_bind/bind_fail', nativeUri: null },
  { path: '/number/file', name: '建档信息', h5Uri: '/home/number_bind/file_message', nativeUri: null },
  { path: '/sendCheck', name: '验证码', h5Uri: '/home/number_bind/send_check_number', nativeUri: null },
  { path: '/createSuccess', name: '建档成功', h5Uri: '/home/number_bind/create_success', nativeUri: null },

  // 一键缴费
  { path: '/paying/unpaid', name: '待缴费', h5Uri: '/home/paying/unpaid_list', nativeUri: null, whiteList: false },
  { path: '/paying/paying', name: '缴费', h5Uri: '/home/paying/paying', nativeUri: null, whiteList: false },
  { path: '/paying/result', name: '缴费结果', h5Uri: '/home/paying/paying_result', nativeUri: null, whiteList: false },
  { path: '/paying/list', name: '费用清单', h5Uri: '/home/paying/cost_list', nativeUri: null, whiteList: false },
  { path: '/paying/paying_insurance', name: '医保确认支付', h5Uri: '/home/paying/paying_insurance', nativeUri: null, whiteList: false },
  { path: '/paying/paying_particulars', name: '医保支付详情', h5Uri: '/home/paying/paying_particulars', nativeUri: null, whiteList: false },



  // 挂号
  { path: '/hospitalList', name: '医院列表', h5Uri: '/home/register/hospital_list', nativeUri: null, whiteList: true },
  { path: '/register/choose', name: '选择就诊人', h5Uri: '/home/register/choose_patient', nativeUri: null, whiteList: false },
  { path: '/register/department', name: '科室列表', h5Uri: '/home/register/department_list', nativeUri: null, whiteList: true },
  { path: '/register/doctor', name: '医生列表', h5Uri: '/home/register/doctor_list', nativeUri: null, whiteList: true },
  { path: '/register/message', name: '挂号信息确认', h5Uri: '/home/register/message_confirm', nativeUri: null, whiteList: false },
  { path: '/register/pay', name: '支付订单', h5Uri: '/home/register/order_pay', nativeUri: null, whiteList: false },
  { path: '/register/success', name: '挂号成功', h5Uri: '/home/register/register_success', nativeUri: null, whiteList: false },

  // 报告查询
  { path: '/report/index', name: '报告查询', h5Uri: '/home/report_search/report_search', nativeUri: null, whiteList: false },
  { path: '/report/report', name: '报告详情', h5Uri: '/home/report_search/report', nativeUri: null, whiteList: false },
  { path: '/report/content', name: '报告内详情', h5Uri: '/home/report_search/report_content', nativeUri: null, whiteList: false },
  { path: '/report/test', name: '检验报告', h5Uri: '/home/report_search/report_test', nativeUri: null, whiteList: false },
  { path: '/report/pdf', name: '检验报告单', h5Uri: '/home/report_search/report_pdf', nativeUri: null, whiteList: false },

  // 门诊病历
  { path: '/medicalRecord', name: '门诊病历', h5Uri: '/home/medical_record/medical_record', nativeUri: null, whiteList: false },
  { path: '/recordDetail', name: '门诊病历详情', h5Uri: '/home/medical_record/record_detail', nativeUri: null, whiteList: false },

  // 智能导诊
  { path: '/recommend_department', name: '科室推荐', h5Uri: '/home/hospital_guide/recommend_department', nativeUri: null, whiteList: true },
  // 智能导诊--外链
  { path: '/hospital_guide', name: '智能导诊', h5Uri: '/home/hospital_guide/hospital_guide', nativeUri: null, whiteList: true },
  { path: '/disease_list', name: '可能的疾病', h5Uri: '/home/hospital_guide/disease_list', nativeUri: null, whiteList: true },
  { path: '/drug_type', name: '药品类型', h5Uri: '/home/hospital_guide/drug_type', nativeUri: null, whiteList: true },
  { path: '/drug_list', name: '药品列表', h5Uri: '/home/hospital_guide/drug_list', nativeUri: null, whiteList: true },
  { path: '/drug_detail', name: '药品详细', h5Uri: '/home/hospital_guide/drug_detail', nativeUri: null, whiteList: true },

  // 医生介绍
  { path: '/register/doctor_intro/dept', name: '医生介绍', h5Uri: '/home/doctor_intro/dept_list', nativeUri: null, whiteList: true },
  { path: '/register/doctor_intro/list', name: '医生列表', h5Uri: '/home/doctor_intro/doctor_list', nativeUri: null, whiteList: true },
  { path: '/register/doctor_intro/detail', name: '医生详情', h5Uri: '/home/doctor_intro/doctor_detail', nativeUri: null, whiteList: true }
]
export default ROUTE_VIEW_HOME



// WEBPACK FOOTER //
// ./src/router/mapping/home.js